import React from 'react'

export default class Title extends React.Component {
  render(){
    const { text } = this.props
    return(
      <div className="col-12">
        <div className="bg-reg description text-align-center p-4">{this.props.children}</div>
      </div>
    )
  }
}

const styles = {

}
